var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#f0d683",
    viewBox: "0 0 72 72",
    width: "64px",
    height: "64px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.828,16.171c1.562,1.562,1.562,4.095,0,5.657l-34,34C21.048,56.609,20.023,57,19,57s-2.048-0.391-2.828-1.171 c-1.562-1.562-1.562-4.095,0-5.657l34-34C51.732,14.61,54.268,14.61,55.828,16.171z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.828,55.829c-1.561,1.562-4.096,1.562-5.656,0l-34-34c-1.562-1.562-1.562-4.095,0-5.657C16.952,15.391,17.977,15,19,15 s2.048,0.391,2.828,1.171l34,34C57.391,51.734,57.391,54.266,55.828,55.829z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.e99fec9ed7ab7a90febdc4ba9b83cbd7.svg";
export { ForwardRef as ReactComponent };